import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import nbrApi from '../../../services/nbrApi';
import { useNavigate, useParams } from 'react-router-dom';

// Validation schema
const validationSchema = Yup.object().shape({
    roomItemName: Yup.string().max(60, 'Room Item Name must be at most 60 characters').required('Room Item Name is required'),
    roomItemDescription: Yup.string().max(100, 'Room Item Description must be at most 100 characters').required('Room Item Description is required'),
    roomItemType: Yup.string().required('Room Item Type is required'),
    status: Yup.string().required('Status is required')
});

let property = JSON.parse(localStorage.getItem('selectedProperty')) || null
const statusOptions = [
    { value: 'active', label: 'Active' },
    { value: 'inactive', label: 'Inactive' },
];
const RoomItemForm = (props) => {
    const { id } = useParams()
    const navigate = useNavigate()
    // State declarations
    const [roomItemTypes, setRoomItemTypes] = useState([]);
    const [statuses, setStatuses] = useState(statusOptions);

    // Formik form handling
    const formik = useFormik({
        initialValues: {
            roomItemName: '',
            roomItemDescription: '',
            roomItemType: '',
            status: ''
        },
        validationSchema: validationSchema,
        onSubmit: values => {
            // console.log(values)
            props.handleAction(values)
        },
    });

    // Fetch room item types by property ID and room type ID
    const getRoomItemTypes = async () => {
        if (!formik.values.roomItemType) {
            setRoomItemTypes([]);
        }
        try {
            const response = await nbrApi.get(`/getroomitemtypesbyp?properties_id=${formik.values.property}`);

            const data = response.data;
            setRoomItemTypes(data?.map(e => ({
                ...e,
                value: e?.rity_id,
                label: e?.type_name
            })));

        } catch (error) {
            console.error('Error fetching data:', error.message);
        }
    };

    // Other useEffect hooks and functions remain unchanged...

    useEffect(() => {
        if (formik.values.property) {
            // Fetch initial data
            getRoomItemTypes();
        }
    }, [formik.values.property]);

    useEffect(() => {
        if (property) {
            formik.setFieldValue('property', property?.value)
        }
    }, [property])

    // default preselect if user comes for EDIT
    useEffect(() => {
        let selectedData = props.roomItemsData?.filter(e => e?.ri_id === parseInt(id))[0]
    
        if (props?.roomItemsData?.length > 0  && !formik.values.roomItemName && !formik.values.roomItemDescription) {
            setRoomItemTypes(props.roomItemsData)
            formik.setFieldValue('roomItemName', selectedData?.item_name)
            formik.setFieldValue('roomItemDescription', selectedData?.item_description)
            formik.setFieldValue('status', 'active')
        }
        if (props?.roomItemsData?.length > 0 && roomItemTypes?.length > 0 && !formik.values.roomItemType) {
            let findData = roomItemTypes?.find(e => e?.label === selectedData?.type_name)
            formik.setFieldValue('roomItemType', parseInt(findData?.value))
            // console.log("Selected Room Item Type Value:", selectedData?.ri_id);
            // console.log("Room Item Types:", roomItemTypes?.find(option => option.value === selectedData?.ri_id));
        }
    }, [formik, id])

    // useEffect(() => {
    //     console.log(formik.values.roomItemType , 'is room Type', roomItemTypes)
    // },[formik.values.roomItemType])
    
    // render
    return (
        <form onSubmit={formik.handleSubmit}>
            <div className="row">
                <div className="form-group mb-3">
                    <label className="m-1 text-black" htmlFor="roomItemName">Room Item Name:</label>
                    <input
                        type="text"
                        id="roomItemName"
                        name="roomItemName"
                        className="form-control"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.roomItemName}
                    />
                    {formik.errors.roomItemName && formik.touched.roomItemName && (
                        <div className="text-danger mt-3">{formik.errors.roomItemName}</div>
                    )}
                </div>
                <div className="form-group mb-3">
                    <label className="m-1 text-black" htmlFor="roomItemDescription">Room Item Description:</label>
                    <textarea
                        id="roomItemDescription"
                        name="roomItemDescription"
                        className="form-control"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.roomItemDescription}
                    />
                    {formik.errors.roomItemDescription && formik.touched.roomItemDescription && (
                        <div className="text-danger mt-3">{formik.errors.roomItemDescription}</div>
                    )}
                </div>
                <div className="form-group mb-3">
                    <label className="m-1 text-black" htmlFor="roomItemType">Room Item Type:</label>
                    <Select
                        className="form-control p-0"
                        options={roomItemTypes}
                        id="roomItemType"
                        onChange={(selectedOption) => formik.setFieldValue("roomItemType", selectedOption.value)}
                        value={roomItemTypes?.find(option => option.value === formik.values.roomItemType) || {}}
                    />
                    {formik.errors.roomItemType && formik.touched.roomItemType && (
                        <div className="text-danger mt-3">{formik.errors.roomItemType}</div>
                    )}
                </div>
                <div className="form-group mb-3">
                    <label className="m-1 text-black" htmlFor="roomItemType">Status:</label>
                    <Select
                        className="form-control p-0"
                        options={statuses}
                        id="status"
                        onChange={(selectedOption) => formik.setFieldValue("status", selectedOption.value)}
                        value={statuses?.find(option => option.value === formik.values.status) || {}}
                    />
                    {formik.errors.status && formik.touched.status && (
                        <div className="text-danger mt-3">{formik.errors.status}</div>
                    )}
                </div>
            </div>
            <button type="submit" className="btn btn-primary">Submit</button>
        </form>
    );
};

export default RoomItemForm;
